import { StyledContainerWrapper } from './StyledComponents';

type Props = {
  type?: 'bar' | 'line' | 'box' | 'badge' | 'chatBubble';
  cover?: boolean;
  dark?: boolean;
  className?: string;
  floatRight?: boolean;
};

const Bone = ({ dark = false, type = 'line', cover = false, floatRight = false }: Props): JSX.Element => {
  return (
    // @ts-expect-error
    <StyledContainerWrapper $type={type} $isCover={cover} $isLight={!dark} $isDark={dark} $isFloatRight={floatRight} />
  );
};

export default Bone;
